import React, { createContext } from 'react';
import GetVehicleDetails from '../../utils/getVehicleDetails';
import { VehicleDetailsOutput } from '../../types';

interface VehicleProviderProps {
  children: React.ReactNode;
  isTier3?: boolean;
}

const locationSearch = typeof window !== 'undefined' ? window.location.search : '';
const vehicleId = new URLSearchParams(locationSearch).get('vehicleId');
const market = new URLSearchParams(locationSearch).get('market');

// This is injected to the application at root level, context will always have a value
export const vehicleContext = createContext<VehicleDetailsOutput>({} as VehicleDetailsOutput);
const { Provider } = vehicleContext;

const VehicleProvider: React.FC<VehicleProviderProps> = ({ children, isTier3 }) => {
  const vehicleDetails = GetVehicleDetails(vehicleId, market, isTier3);

  return <Provider value={vehicleDetails}>{children}</Provider>;
};

export default VehicleProvider;
